<template>
  <li>
    <VuepalLink
      v-if="source"
      :to="source.to"
      class="group flex flex-col py-[60px] transition"
    >
      <h3 class="highlight text-3xl lg:text-4xl mt-6 md:mt-0" v-html="title" />
      <div v-if="breadcrumb" class="text-primary-500 my-5">
        <span v-for="(segment, index) in breadcrumb" :key="index">
          <span :class="{ 'font-bold': index === 0 }">{{ segment }}</span>
          <span v-if="index < breadcrumb.length - 1"> &gt; </span>
        </span>
      </div>
      <div v-if="source.text" class="highlight" v-html="text" />
      <div class="text-primary-500 font-bold mt-5">
        {{ $texts('more_information', 'Mehr Informationen') }}
      </div>
    </VuepalLink>
  </li>
</template>

<script lang="ts" setup>
import type { SearchItemFragment } from '#graphql-operations'

const props = defineProps<{
  source?: SearchItemFragment
  highlight?: { text?: string; title?: string }
}>()

const { $texts } = useEasyTexts()

const title = computed(() => props.highlight?.title ?? props.source?.title)
const text = computed(() => {
  const date = props.source?.date
    ? `${new Intl.DateTimeFormat('de-CH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(props.source?.date * 1000))} - `
    : ''
  return (
    date + (props.highlight?.text ?? props.source?.lead ?? props.source?.teaser)
  )
})

const breadcrumb = computed(() => {
  if (props.source?.breadcrumb_text) {
    // Remove first elememt (Homepage) and last element (current page)
    return props.source.breadcrumb_text.slice(1, -1)
  }
  return []
})
</script>

<style lang="postcss">
.highlight em {
  @apply bg-gray-100 not-italic font-bold;
}
</style>
